import { render, staticRenderFns } from "./skiiScoreList.vue?vue&type=template&id=4f24e074&scoped=true"
import script from "./skiiScoreList.vue?vue&type=script&lang=js"
export * from "./skiiScoreList.vue?vue&type=script&lang=js"
import style0 from "./skiiScoreList.vue?vue&type=style&index=0&id=4f24e074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f24e074",
  null
  
)

export default component.exports